<template>
    <div id="ProfilePhoneSettings">
        <header>
            <VuiButton type="text" class="btn" @click.native="$router.go(-1)">返回</VuiButton>
            <p class="title">修改手机</p>
            <VuiButton type="text" class="btn" style="visibility: hidden;">完成</VuiButton>
        </header>
        <main>
            <section>
                <label>手机</label>
                <div class="profile-content">
                    <input :value="phone" class="profile-phone" placeholder="请输入手机号" type="number" @input="inpuField"
                           data-field="phone"></input>
                </div>
                <div class="profile-send" @click="getSms" v-if="countDown===60">
                    获取验证码
                </div>
                <div class="profile-send" v-if="countDown<60">
                    {{countDown}}s后获取
                </div>
            </section>
            <section>
                <label>验证码</label>
                <div class="profile-content">
                    <input v-focus :value="verify" placeholder="请输入验证码" type="number" @input="inpuField"
                           data-field="verify"></input>
                </div>
                <div class="profile-clear" v-if="verify" data-field="verify" @click="clear">
                    <image src="../../../assets/img/clear.png"></image>
                </div>
            </section>
        </main>
        <footer>
            <section>
                <VuiButton type="text" class="btn" @click.native="submit">确定修改</VuiButton>
            </section>
        </footer>
        <Spin size="large" fix v-if="loading"></Spin>
    </div>
</template>

<script>
    import router from '@/router'

    export default {
        name: 'phone',
        data() {
            return {
                countDown: 60,
                verify: '',
                phone: this.$route.params.phone,
                loading: false,
            }
        },
        created() {
        },
        methods: {
            getSms: function () {
                let phone = this.phone;
                if (phone.length !== 11) {
                    router.app.$Message.error('手机号码错误');
                    return false;
                }
                let interval = setInterval(() => {
                    if (this.countDown > 0) {
                        let countDown = this.countDown;
                        countDown = countDown - 1;
                        this.countDown = countDown;
                    } else {
                        clearInterval(interval);
                        this.countDown = 60;
                    }
                }, 1000)
                this.$store.dispatch('app/sendMsg', {phone}).then((res => {
                    router.app.$Message.info('发送成功');
                }))
            },
            submit: function () {
                const param = {};
                param.phone = this.phone;
                if (param.phone.length !== 11) {
                    router.app.$Message.error('手机号码错误');
                    return false;
                }
                param.code = this.verify;
                if (param.code.length !== 4) {
                    router.app.$Message.error('验证码错误');
                    return false;
                }
                this.loading = true;
                this.$store.dispatch('user/updateUser', param).then(res => {
                    this.loading = false;
                    router.app.$Message.info('信息修改成功');
                    this.$router.go(-1)
                })
            },
            inpuField: function (e) {
                let field = e.currentTarget.dataset.field;
                let value = e.target.value.replace(/(^\s*)|(\s*$)/g, "");
                if (field === 'phone') {
                    this.phone = value;
                }
                if (field === 'verify') {
                    this.verify = value;
                }
            },
            clear: function (e) {
                let field = e.currentTarget.dataset.field;
                if (field === 'phone') {
                    this.phone = '';
                }
                if (field === 'verify') {
                    this.verify = '';
                }
            },
        }
    }
</script>

<style lang="scss">

    #ProfilePhoneSettings {
        min-height: 100vh;
        background-color: #f0f0f0;

        .profile-send {
            color: #fa8919;
            font-size: 14px;
            white-space: nowrap;
        }

        .profile-phone {
        }

        .btn {
            padding: 0;
            height: auto;
            background-color: transparent;
            font-size: 17px;
            line-height: 24px;
            font-weight: bold;
            color: #ed6c00;
        }

        .height-auto {
            height: auto;
        }

        section {
            padding: 11px 20px 11px 0;
            margin-left: 20px;
            border-bottom: 1px solid #e5e4e4;
            display: -webkit-box;
            justify-content: space-between;
            align-items: center;

            &:last-child {
                border-bottom: none;
            }
        }

        header {
            padding: 10px 20px;
            display: flex;
            justify-content: space-between;
            background-color: #ffffff;
            border-bottom: 1px solid rgba(0, 0, 0, 0.15);

            .title {
                font-size: 17px;
                line-height: 24px;
                font-weight: bold;
            }
        }

        main {
            margin-top: 20px;
            background-color: #ffffff;
            border-top: 1px solid rgba(0, 0, 0, 0.15);
            border-bottom: 1px solid rgba(0, 0, 0, 0.15);

            label {
                width: 120px;
                font-size: 16px;
                line-height: 22px;
                color: #000000;
                flex-shrink: 0;
                flex-grow: 0;
            }

            input,
            textarea {
                border: none;
                outline: none;
                margin: 0;
                padding: 0;
                font-size: 16px;
                line-height: 22px;
                letter-spacing: 0.3px;
                text-align: right;
                flex-shrink: 1;
                flex-grow: 1;
                background-color: transparent;
                resize: none;
            }
        }

        footer {
            margin-top: 20px;
            background-color: #ffffff;
            border-top: 1px solid rgba(0, 0, 0, 0.15);
            border-bottom: 1px solid rgba(0, 0, 0, 0.15);
        }
    }
</style>
